import { useMemo, useEffect } from 'react'

import 'reactjs-popup/dist/index.css'
import '../grile/grile.css'
import '../../highlight.min.css'
import PickSubject from './components/PickSubject'
import Grid from '../../components/Grid'

import { handleGetGridDifficulty, removeTutorialOverlay } from '../../utils'
import GridsNavigation from '../../components/Grid/components/GridsSidebar'
import DashboardLayout from '../../layouts/LayoutContainers/DashboardLayout'
import Spinner from '../../components/Spinner'
import useSubject from './useSubject'
import CustomSubject from './components/CustomSubject'

import SubjectContent from './components/SubjectContent'
import SubjectTabs from './components/SubjectTabs'
import CustomTour from 'components/CustomTour'
import { useAuthContext } from 'context'

const Subiect = () => {
  const {
    answer,
    hint,
    currentSubject,
    handleGetHint,
    checkbox,
    currentGridIndex,
    setCheckbox,
    handleChangeAnswer,
    handleGetRemainingTimeString,
    handleSubmit,
    handleCurrentGrid,
    handlePrevGrid,
    handleNextGrid,
    isLoadingSubject,
    dropdownValue,
    handleNewSubjectWindow,
    isSubmitted,
    allTags,
    setCurrentSubject,
    isSmallDevice,
    subjectOptions,
    handleStartNewSubject,
    setDropdownValue,
    generateFaculty,
    setGenerateFaculty,
    height,
    setHeight,
    handleGetSubjectTimeString,
    isSkippingSubject,
    isSubmittingSubject,
    isLoadingSubjectByCode,
    coursesForFilters,
    handleChangeCoursesForFilters,
    setSelectedSubjectType,
    selectedSubjectType,
    handleSaveGrid,
    handleRemoveSavedGrid,
    selectedTab,
    handleTabChange,
    nextSubjectDate,
    participated,
    lastSubjectRanking,
    currentUser,
    nextSubjectID,
    explainAnswers,
  } = useSubject()

  const { userDetails } = useAuthContext()

  if (!userDetails?.tutorial) {
    removeTutorialOverlay()
  }

  const subjectContent = useMemo(() => {
    return (
      <div className="flex  gap-5 justify-center p-0">
        <div className="w-full xl:w-fit">
          <Grid
            isGridSaved={currentSubject?.grile[currentGridIndex]?.is_saved}
            handleSaveGrid={handleSaveGrid}
            handleRemoveSavedGrid={handleRemoveSavedGrid}
            pagesAuto={currentSubject?.grile[currentGridIndex]?.pages_auto}
            pagesManual={currentSubject?.grile[currentGridIndex]?.pages_manual}
            book={{
              book_name: currentSubject?.grile[currentGridIndex]?.book_name,
              book_page_offset:
                currentSubject?.grile[currentGridIndex]?.book_page_offset,
            }}
            books={currentSubject?.books}
            hasHint={currentSubject?.grile[currentGridIndex]?.hint}
            allowHint={currentSubject?.allow_hint}
            beginTimestamp={currentSubject?.begin_timestamp}
            endTimestamp={currentSubject?.end_timestamp}
            isMultipleChoice={
              currentSubject?.grile[currentGridIndex]?.multiple_choice
            }
            gridId={currentSubject?.grile?.[currentGridIndex]?.id}
            isSkippingSubject={isSkippingSubject}
            isSubmittingSubject={isSubmittingSubject}
            setHeight={setHeight}
            height={height}
            source={currentSubject?.grile?.[currentGridIndex]?.source}
            isSubjectGenerated={dropdownValue?.value === -1}
            handleNewSubjectWindow={handleNewSubjectWindow}
            isLoading={isLoadingSubject}
            isSubmitted={isSubmitted}
            allTags={allTags}
            setCurrentSubject={setCurrentSubject}
            difficulty={handleGetGridDifficulty(
              currentSubject?.grile[currentGridIndex]?.difficulty,
            )}
            gridTags={currentSubject?.grile?.[currentGridIndex]?.capitole}
            handleSubmit={handleSubmit}
            gridsFromSubject={currentSubject?.grile}
            currentGridIndex={currentGridIndex}
            currentGridId={currentSubject?.grile?.[currentGridIndex].id}
            checkbox={checkbox}
            userChoice={currentSubject?.grile?.[currentGridIndex]?.choice}
            handleUserGetHint={handleGetHint}
            answer={answer}
            handleGetRemainingTimeString={handleGetRemainingTimeString}
            isSubject
            setCheckbox={setCheckbox}
            handleChangeAnswer={handleChangeAnswer}
            started={true}
            hint={hint?.[currentGridIndex]}
            currentGrila={currentSubject?.grile?.[currentGridIndex]?.json}
            handleNextGrid={handleNextGrid}
            handlePrevGrid={handlePrevGrid}
            handleCurrentGrid={handleCurrentGrid}
            explainAnswers={explainAnswers}
          />
        </div>

        {!isSmallDevice ? (
          <div className="relative hidden xl:block">
            <GridsNavigation
              beginTimestamp={currentSubject?.begin_timestamp}
              endTimestamp={currentSubject?.end_timestamp}
              setHeight={setHeight}
              isSkippingSubject={isSkippingSubject}
              isLoadingSubject={isLoadingSubject}
              handleNewSubjectWindow={handleNewSubjectWindow}
              setCurrentSubject={setCurrentSubject}
              currentGridIndex={currentGridIndex}
              answer={answer}
              handleCurrentGrid={handleCurrentGrid}
              gridsFromSubject={currentSubject?.grile}
            />
          </div>
        ) : null}
      </div>
    )
  }, [
    answer,
    hint,
    setCheckbox,
    handleChangeAnswer,
    handleGetRemainingTimeString,
    checkbox,
    currentSubject,
    handleSubmit,
    handleCurrentGrid,
    currentGridIndex,
    handlePrevGrid,
    handleNextGrid,
    isLoadingSubject,
    handleSaveGrid,
    handleRemoveSavedGrid,
    allTags,
    dropdownValue?.value,
    explainAnswers,
    handleGetHint,
    handleNewSubjectWindow,
    height,
    isSkippingSubject,
    isSmallDevice,
    isSubmitted,
    isSubmittingSubject,
    setCurrentSubject,
    setHeight,
  ])

  return (
    <DashboardLayout>
      {currentSubject || isLoadingSubject ? (
        isSmallDevice ? (
          <Grid
            isGridSaved={currentSubject?.grile[currentGridIndex]?.is_saved}
            handleSaveGrid={handleSaveGrid}
            handleRemoveSavedGrid={handleRemoveSavedGrid}
            pagesAuto={currentSubject?.grile[currentGridIndex]?.pages_auto}
            pagesManual={currentSubject?.grile[currentGridIndex]?.pages_manual}
            book={currentSubject?.grile[currentGridIndex]?.book}
            hasHint={currentSubject?.grile[currentGridIndex]?.hint}
            allowHint={currentSubject?.allow_hint}
            beginTimestamp={currentSubject?.begin_timestamp}
            endTimestamp={currentSubject?.end_timestamp}
            isMultipleChoice={
              currentSubject?.grile[currentGridIndex]?.multiple_choice
            }
            isSubmittingSubject={isSubmittingSubject}
            isSkippingSubject={isSkippingSubject}
            height={height}
            setHeight={setHeight}
            isSubjectGenerated={dropdownValue?.value === -1}
            handleNewSubjectWindow={handleNewSubjectWindow}
            allTags={allTags}
            isLoading={isLoadingSubject}
            isSubmitted={isSubmitted}
            setCurrentSubject={setCurrentSubject}
            difficulty={handleGetGridDifficulty(
              currentSubject?.grile[currentGridIndex]?.difficulty,
            )}
            source={currentSubject?.grile?.[currentGridIndex]?.source}
            gridTags={currentSubject?.grile?.[currentGridIndex]?.capitole}
            handleSubmit={handleSubmit}
            gridsFromSubject={currentSubject?.grile}
            currentGridIndex={currentGridIndex}
            currentGridId={currentSubject?.grile?.[currentGridIndex].id}
            checkbox={checkbox}
            userChoice={currentSubject?.grile?.[currentGridIndex]?.choice}
            handleUserGetHint={handleGetHint}
            answer={answer}
            handleGetRemainingTimeString={handleGetRemainingTimeString}
            endTrial={false}
            isSubject
            setCheckbox={setCheckbox}
            handleChangeAnswer={handleChangeAnswer}
            started={true}
            hint={hint?.[currentGridIndex]}
            currentGrila={currentSubject?.grile?.[currentGridIndex]?.json}
            handleNextGrid={handleNextGrid}
            handlePrevGrid={handlePrevGrid}
            handleCurrentGrid={handleCurrentGrid}
          />
        ) : (
          <div className="flex justify-center p-0">{subjectContent}</div>
        )
      ) : (
        <div className="flex max-w-[900px] ml-auto mr-auto transition-all duration-700 ease-in-out">
          <div className="ml-auto mr-auto relative w-full ">
            <SubjectTabs
              tabs={['Antrenament', 'Simulări']}
              activeTab={selectedTab}
              changeTab={handleTabChange}
            />
            <SubjectContent>
              {selectedTab === 0 &&
                (subjectOptions && dropdownValue ? (
                  <PickSubject
                    setSelectedSubjectType={setSelectedSubjectType}
                    selectedSubjectType={selectedSubjectType}
                    coursesForFilters={coursesForFilters}
                    handleChangeCoursesForFilters={
                      handleChangeCoursesForFilters
                    }
                    isLoadingSubjectByCode={isLoadingSubjectByCode}
                    handleGetSubjectTimeString={handleGetSubjectTimeString}
                    startNewSubject={handleStartNewSubject}
                    subjectOptions={subjectOptions}
                    dropdownValue={dropdownValue}
                    setDropdownValue={setDropdownValue}
                    generateFaculty={generateFaculty}
                    setGenerateFaculty={setGenerateFaculty}
                    isLoadingSubject={isLoadingSubject}
                  />
                ) : (
                  <div className="w-full min-h-[250px] flex justify-center items-center">
                    <Spinner />
                    <CustomTour isOpen={false} />
                  </div>
                ))}
              {selectedTab == 1 && (
                <CustomSubject
                  nextSubjectDate={nextSubjectDate}
                  participated={participated}
                  rankingData={lastSubjectRanking}
                  currentUser={currentUser}
                  startNewSubject={handleStartNewSubject}
                  subjectID={nextSubjectID}
                />
              )}
            </SubjectContent>
          </div>
        </div>
      )}
    </DashboardLayout>
  )
}
export default Subiect
